// Link detection and parsing utilities
export const linkUtils = {
  // Detect if a string is a valid URL
  isUrl: (text: string): boolean => {
    try {
      new URL(text);
      return true;
    } catch {
      return false;
    }
  },

  // Detect if a string contains URLs
  containsUrl: (text: string): boolean => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return urlRegex.test(text);
  },

  // Convert URLs in text to HTML links
  textToHtmlWithLinks: (text: string): string => {
    if (!text) return text;
    
    // Regex to match URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    
    return text.replace(urlRegex, (url) => {
      // Clean up the URL (remove trailing punctuation)
      const cleanUrl = url.replace(/[.,;:!?]+$/, '');
      const trailingPunctuation = url.slice(cleanUrl.length);
      
      return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer">${cleanUrl}</a>${trailingPunctuation}`;
    });
  },

  // Extract links from HTML content
  extractLinks: (html: string): Array<{url: string, text: string}> => {
    const links: Array<{url: string, text: string}> = [];
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const linkElements = doc.querySelectorAll('a');
    
    linkElements.forEach(link => {
      links.push({
        url: link.getAttribute('href') || '',
        text: link.textContent || ''
      });
    });
    
    return links;
  },

  // Convert HTML links back to plain text
  htmlToText: (html: string): string => {
    if (!html) return html;
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  },

  // Validate URL format
  validateUrl: (url: string): boolean => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  },

  // Format URL for display (truncate if too long)
  formatUrlForDisplay: (url: string, maxLength: number = 50): string => {
    if (url.length <= maxLength) return url;
    return url.substring(0, maxLength - 3) + '...';
  }
};
